import Index from './UsersIndex';
import Show from './ShowUser';

export default { Index, Show };
